module.exports = __webpack_public_path__ + "img/vision.219f6f61.png";